import { addMilliseconds } from 'date-fns';
import { createReducer } from '@reduxjs/toolkit';

import * as actionTypes from '../actionTypes';
import { AWS_MAX_DURATION } from '../constants';

/**
 * @typedef {string} TimeoutAtState
 */

/** @type {TimeoutAtState} */
const initialState = null;

const set = () => addMilliseconds(new Date(), AWS_MAX_DURATION).toISOString();

export default createReducer(initialState, (builder) => {
  builder.addCase(actionTypes.SOCKET_INITIALIZED, set);
});
